import * as React from 'react';

import { TApplicationContext } from '../../../../../../../node/types/application';

import {
  getCustomerNameByInn,
  IGetCustomerNameByInnParamters,
  IGetCustomerNameByInnResult,
  EGetCustomerNameByInnStatus,
} from '../../../../../../services/billingAccounts/getCustomerNameByInn';
import { AnyFunction } from '../../../../../../types/AnyFunction';
import { executeFunction } from '../../../../../../utils/executeFunction';

export type UseFetchCustomerNameByInn = Partial<Record<'onRequest', AnyFunction>> &
  Partial<Record<'onSuccess' | 'onFailure' | 'onCriticalError' | 'onDone', AnyFunction<[IGetCustomerNameByInnResult]>>>;

export function useFetchCustomerNameByInn(
  httpApi: TApplicationContext['httpApi'],
  logger: TApplicationContext['logger'],
) {
  const [pendingState, setPendingState] = React.useState<boolean>(false);

  const callRequest = (
    parameters: IGetCustomerNameByInnParamters,
    callback: UseFetchCustomerNameByInn = Object.create(null),
  ) => {
    (async () => {
      setPendingState(true);
      const { onFailure, onSuccess, onRequest, onCriticalError, onDone } = callback;

      setPendingState(true);

      executeFunction(onRequest);

      const response = (await getCustomerNameByInn(
        { httpApi, logger },
        parameters,
      )) as unknown as IGetCustomerNameByInnResult;

      switch (response.status) {
        case EGetCustomerNameByInnStatus.Success:
          executeFunction(onSuccess, response);
          break;
        case EGetCustomerNameByInnStatus.Error:
          executeFunction(onFailure, response);
          break;
        case EGetCustomerNameByInnStatus.CriticalError:
          executeFunction(onCriticalError, response);
          break;
      }

      setPendingState(false);

      executeFunction(onDone, response);
    })();
  };

  return { callRequest, pending: pendingState };
}
